/** Document tags for Filed Copies uploads (individual category). */
export const CUSTOM_FILED_COPIES_DOCUMENT_TAG = "Custom";

export const INDIVIDUAL_FILED_COPIES_DOCUMENT_TAGS = [
  { id: "Filed Tax Returns", value: "Filed Tax Returns" },
  { id: "Estimated Tax Payments", value: "Estimated Tax Payments" },
  { id: CUSTOM_FILED_COPIES_DOCUMENT_TAG, value: "Custom" },
];

/** Document tags for Filed Copies uploads (business category). */
export const BUSINESS_FILED_COPIES_DOCUMENT_TAGS = [
  { id: "Filed Tax Returns", value: "Filed Tax Returns" },
  { id: "Estimated Tax Payments", value: "Estimated Tax Payments" },
  { id: "K-1 Packages", value: "K-1 Packages" },
  { id: CUSTOM_FILED_COPIES_DOCUMENT_TAG, value: "Custom" },
];

export function getFiledCopiesDocumentTagOptions(documentCategory) {
  const category = String(documentCategory || "")
    .toLowerCase()
    .trim();
  return category === "business"
    ? BUSINESS_FILED_COPIES_DOCUMENT_TAGS
    : INDIVIDUAL_FILED_COPIES_DOCUMENT_TAGS;
}

export function isCustomFiledCopiesDocumentTag(tag, documentCategory) {
  const value = String(tag || "").trim();
  if (!value || value === CUSTOM_FILED_COPIES_DOCUMENT_TAG) return true;
  const presets = getFiledCopiesDocumentTagOptions(documentCategory)
    .map((option) => option.id)
    .filter((id) => id !== CUSTOM_FILED_COPIES_DOCUMENT_TAG);
  return !presets.includes(value);
}
